export default __webpack_public_path__ + "static/media/eight.daecae56.svg";